import React from 'react';

import { Box, Skeleton } from '@mui/material';

const bottomBoxStyles = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  gap: '2.4rem',
};

const FeesSummarySkeleton = () => (
  <>
    <div className="w-full flex gap-48">
      {Array.from({ length: 3 }).map((_, ind) => (
        <Skeleton
          animation="pulse"
          height={32}
          key={`${ind}-first`}
          variant="rounded"
          width="10%"
        />
      ))}
    </div>

    <Skeleton animation="pulse" className="mt-16 mb-24" height={1} variant="rounded" width="95%" />

    <Box sx={bottomBoxStyles}>
      {Array.from({ length: 5 }).map((_, ind) => (
        <div className="w-full flex items-center gap-12" key={`${ind}-first`}>
          <Skeleton animation="pulse" height={40} variant="circular" width={40} />
          <Skeleton animation="pulse" className="grow" height={48} variant="rounded" />
        </div>
      ))}
    </Box>
  </>
);

export default FeesSummarySkeleton;
